const MUserPanelOverview = ({ data }) => {
  return (
      {
        /* REPLACEMENT */
      }
  )
}

export default MUserPanelOverview
